import Vue from 'vue'
import VtInput from '@/components/common/VtInput.vue'
Vue.component('VtInput', VtInput)
